import { getStoreState } from 'config/store'
import DriftQueryParams from 'constants/driftQueryParams'
import qs from 'query-string'
import { pathOr } from 'ramda'

const OneshotTokenIdentityProvider = {
  identify: () => {
    const locationSearch = pathOr(null, ['session', 'context', 'page', 'search'], getStoreState())

    if (!locationSearch) {
      return null
    }

    const urlParameters = qs.parse(locationSearch)

    if (!urlParameters[DriftQueryParams.ONESHOT_TOKEN]) {
      return null
    }

    return urlParameters[DriftQueryParams.ONESHOT_TOKEN]
  }
}

export default OneshotTokenIdentityProvider
